import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { UnitValue, UnitValueControl } from 'src/app/form-controls/unit-value/unit-value.control';
import { SheetActionControlsBase } from 'src/app/services/sheets-renderer.service';
import { Row, Slot } from 'src/app/types/aggregate-graph.types';
import { MedicationInfusionActionV2 } from 'src/app/types/sheet-action-aggregate-graph.types';
import { ActionFormComponent } from '../../action-form/action-form.component';
import { CommonActionControlsComponent } from '../../common-action-controls/common-action-controls.component';

interface MedicationInfusionActionFormGroup {
	rate: FormControl<UnitValue | null>;
}

@Component({
    selector: 'app-medication-infusion-action-controls-v2',
    templateUrl: './medication-infusion-action-controls-v2.component.html',
    styleUrls: ['../../../common.scss', './medication-infusion-action-controls-v2.component.scss'],
    imports: [ReactiveFormsModule, CommonActionControlsComponent, ActionFormComponent, UnitValueControl],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MedicationInfusionActionControlsComponentV2 implements SheetActionControlsBase, OnInit {

	slot!: Slot | null;
	action!: MedicationInfusionActionV2;

	@Input('slot') set updateSlot(slot: Slot | null) {
		this.slot = slot;
		this.action = slot?.action as MedicationInfusionActionV2;
	}

	@Input() form!: FormGroup<MedicationInfusionActionFormGroup>;
	@Input() item!: Row | null;
	
	constructor(private formBuilder: FormBuilder) {
	}

	ngOnInit() {
		this.form.addControl('rate', this.formBuilder.control(this.action?.rate ?? null));
	}
}